const svgToDataUri = (svg) => `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;

const createAvatarSvg = ({ background, accent, bust, hair }) => `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96" role="img" aria-hidden="true">
    <defs>
      <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stop-color="${background}" />
        <stop offset="100%" stop-color="${accent}" />
      </linearGradient>
    </defs>
    <rect width="96" height="96" rx="48" fill="url(#bg)" />
    <circle cx="48" cy="35" r="16" fill="#F7D7C4" />
    ${hair}
    <path d="${bust}" fill="#F8FAFC" />
  </svg>
`;

const avatarByGender = {
  male: createAvatarSvg({
    background: "#1D4ED8",
    accent: "#38BDF8",
    hair: '<path d="M32 35c0-10 7-18 16-18s16 8 16 18c-4-5-10-8-16-8s-12 3-16 8Z" fill="#0F172A" />',
    bust: "M22 79c2-14 13-22 26-22s24 8 26 22H22Z",
  }),
  female: createAvatarSvg({
    background: "#DB2777",
    accent: "#F9A8D4",
    hair: '<path d="M26 40c0-14 10-24 22-24s22 10 22 24c0 7-3 13-7 18l-4-12c-3 3-7 5-11 5s-8-2-11-5l-4 12c-4-5-7-11-7-18Z" fill="#7C2D12" />',
    bust: "M18 80c4-13 15-21 30-21s26 8 30 21H18Z",
  }),
  neutral: createAvatarSvg({
    background: "#475569",
    accent: "#94A3B8",
    hair: '<path d="M30 36c0-11 8-19 18-19s18 8 18 19c-5-4-11-6-18-6s-13 2-18 6Z" fill="#1E293B" />',
    bust: "M20 80c3-13 14-21 28-21s25 8 28 21H20Z",
  }),
};

export const normalizeGender = (value) => {
  const raw = `${value || ""}`.trim().toLowerCase();
  if (raw === "male" || raw === "m") return "male";
  if (raw === "female" || raw === "f") return "female";
  return "neutral";
};

export const getGenderAvatarUrl = (value) =>
  svgToDataUri(avatarByGender[normalizeGender(value)] || avatarByGender.neutral);

export const getLeaderboardEntryGender = (entry, fallback = "") =>
  entry?.gender ||
  entry?.student?.gender ||
  entry?.user?.gender ||
  fallback;
